import { defineStore } from 'pinia'
import { setCookie, getCookie, deleteCookie } from '@/store/cookie'

//const channel = new BroadcastChannel('auth_channel')

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: getCookie('token'),
    user: null,
  }),

  actions: {
    setToken(token) {
      //this.token = token
      // すでに同じ token なら何もしない（無限ループ防止）
      //if (this.token === token) return
      this.token = token
      setCookie('token', token, 1) // 1日保持
    },

    clear() {
      this.token = null
      this.user = null
      deleteCookie('token')
    },
  },
})
